import { Header, Logo } from '@mds/merck-design-system-dev'
import React from 'react'

function MyHeader() {
  return (
      <Header title={''} Logo={<Logo theme="teal" logo="nonUsCanada" />} />
  )
}

export default MyHeader